"use client";

/**
 * "L'échange standard, comment ça marche ?" — a SLIM dark strip, commerce
 * register: compact heading left, the three numbered steps inline (solid green
 * number chip + title + one-line text). No big cards, no textures — dark gray,
 * white, solid green. Content: { title, subtitle, steps: [{ title, text }] }.
 */
type Step = { title?: string; text?: string };

export function StepsSectionRenderer({ component }: { component: { content?: { title?: string; subtitle?: string; steps?: Step[] } } }) {
  const { title, subtitle, steps = [] } = component.content ?? {};
  return (
    <section className="apa-edge-glow mx-[calc(50%-50vw)] w-screen bg-[var(--color-carbon)] py-8 text-white md:py-10">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        {title ? (
          <div className="mb-6 flex flex-wrap items-baseline gap-x-4 gap-y-1">
            <h2 className="text-lg font-bold tracking-tight md:text-xl" style={{ fontFamily: "var(--font-aleo)" }}>
              {title.includes("?") ? (
                <>{title.split("?")[0].trimEnd()}{" "}<span className="text-[#00B862]">?</span></>
              ) : title}
            </h2>
            {subtitle ? <p className="text-sm text-white/55">{subtitle}</p> : null}
          </div>
        ) : null}
        <div className="grid gap-5 md:grid-cols-3 md:gap-8">
          {steps.map((s, i) => (
            <div key={s.title ?? i} className="flex items-start gap-3">
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-[#00B862] text-sm font-extrabold text-white">
                {i + 1}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-bold md:text-base">{s.title}</h3>
                {s.text ? <p className="mt-1 text-xs leading-relaxed text-white/60 md:text-sm">{s.text}</p> : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
